//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Search from "@/components/college/search.vue";
import CourseItem from "@/components/college/courseItem.vue";
import { majorSourceList } from "@/api/college/index";
export default {
  components: {
    CourseItem: CourseItem,
    Search: Search
  },
  props: {},
  data: function data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 18,
        courseName: '',
        majorName: ''
      },
      total: 0,
      majorSource: []
    };
  },
  created: function created() {
    this.getMajorSource();
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getMajorSource();
    },
    //专业资源库
    getMajorSource: function getMajorSource() {
      var _this = this;
      majorSourceList({
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        emceeCompanyname: this.$store.getters.wCode,
        onState: "1",
        keyWord: this.query.courseName,
        majorName: this.query.majorName
        // provinceId: this.$store.getters.provinceId,
      }).then(function (res) {
        if (res.code === 2000) {
          for (var i in res.data.list) {
            if (res.data.list[i].previewPic) {
              var queryIndex = res.data.list[i].previewPic.indexOf('?');
              if (queryIndex !== -1) {
                res.data.list[i].previewPic = res.data.list[i].previewPic.substring(0, queryIndex);
              }
            }
          }
          _this.majorSource = res.data.list;
          _this.total = res.data.total;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getMajorSource();
    }
  }
};